import React from "react";

function valueOrZero(value) {
  const number = Number(value);

  return Number.isFinite(number)
    ? number
    : 0;
}

function InfoCard({
  label,
  value,
  color = "#0f172a",
}) {
  return (
    <div
      style={{
        padding: 10,
        borderRadius: 12,
        border:
          "1px solid #e2e8f0",
        background: "#ffffff",
        minWidth: 0,
      }}
    >
      <div
        style={{
          color: "#64748b",
          fontSize: 9,
          fontWeight: 900,
          textTransform:
            "uppercase",
        }}
      >
        {label}
      </div>

      <div
        style={{
          marginTop: 5,
          color,
          fontSize: 15,
          fontWeight: 950,
          overflowWrap:
            "anywhere",
        }}
      >
        {value}
      </div>
    </div>
  );
}

export default function Shift360StaffingSnapshot({
  worker,
  eligibilitySummary,
}) {
  const summary =
    eligibilitySummary || {};

  const total =
    valueOrZero(
      summary.total
    );

  const eligible =
    valueOrZero(
      summary.eligible
    );

  const ineligible =
    valueOrZero(
      summary.ineligible
    );

  const roleMismatch =
    valueOrZero(
      summary.roleMismatch
    );

  const credentialIssue =
    valueOrZero(
      summary.credentialIssue
    );

  const unavailable =
    valueOrZero(
      summary.unavailable
    );

  const overlap =
    valueOrZero(
      summary.overlap
    );

  const workerName =
    worker?.displayName ||
    worker?.name ||
    worker?.fullName ||
    worker?.email ||
    "Unassigned";

  const workerEmail =
    worker?.email ||
    "No worker assigned";

  const readinessLabel =
    eligible > 0
      ? `${eligible} Eligible`
      : worker
      ? "Worker Assigned"
      : "No Eligible Workers";

  const readinessColor =
    eligible > 0 ||
    worker
      ? "#166534"
      : "#b91c1c";

  return (
    <div
      style={{
        padding: 13,
        borderRadius: 14,
        border:
          "1px solid #d1fae5",
        background:
          "#f0fdf4",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems:
            "flex-start",
          gap: 10,
        }}
      >
        <div>
          <div
            style={{
              color: "#166534",
              fontSize: 13,
              fontWeight: 950,
            }}
          >
            Staffing Snapshot
          </div>

          <div
            style={{
              marginTop: 3,
              color: "#64748b",
              fontSize: 10,
              fontWeight: 750,
            }}
          >
            Worker assignment and
            eligible facility pool.
          </div>
        </div>

        <div
          style={{
            padding:
              "5px 8px",
            borderRadius: 999,
            background:
              "#ffffff",
            border:
              "1px solid #bbf7d0",
            color:
              readinessColor,
            fontSize: 9,
            fontWeight: 950,
            whiteSpace:
              "nowrap",
          }}
        >
          {readinessLabel}
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(2, minmax(0, 1fr))",
          gap: 8,
          marginTop: 10,
        }}
      >
        <InfoCard
          label="Assigned Worker"
          value={workerName}
          color={
            worker
              ? "#166534"
              : "#b45309"
          }
        />

        <InfoCard
          label="Worker Email"
          value={workerEmail}
        />

        <InfoCard
          label="Eligible Pool"
          value={`${eligible} / ${total}`}
          color={
            eligible > 0
              ? "#166534"
              : "#b91c1c"
          }
        />

        <InfoCard
          label="Ineligible"
          value={ineligible}
          color={
            ineligible > 0
              ? "#b45309"
              : "#166534"
          }
        />
      </div>

      <div
        style={{
          marginTop: 10,
          paddingTop: 10,
          borderTop:
            "1px solid #d1fae5",
        }}
      >
        <div
          style={{
            color: "#475569",
            fontSize: 9,
            fontWeight: 900,
            textTransform:
              "uppercase",
          }}
        >
          Eligibility Exclusions
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(2, minmax(0, 1fr))",
            gap: 8,
            marginTop: 8,
          }}
        >
          <InfoCard
            label="Role Mismatch"
            value={roleMismatch}
            color={
              roleMismatch > 0
                ? "#b45309"
                : "#166534"
            }
          />

          <InfoCard
            label="Credential Issue"
            value={credentialIssue}
            color={
              credentialIssue > 0
                ? "#b91c1c"
                : "#166534"
            }
          />

          <InfoCard
            label="Unavailable"
            value={unavailable}
            color={
              unavailable > 0
                ? "#b45309"
                : "#166534"
            }
          />

          <InfoCard
            label="Shift Conflict"
            value={overlap}
            color={
              overlap > 0
                ? "#b91c1c"
                : "#166534"
            }
          />
        </div>
      </div>
    </div>
  );
}